import React from 'react';
import { SocialMediaType } from '../../ts-types/custom.types';

type Props = {
  siteName: string,
  socialMedia: SocialMediaType[],
};

const Footer: React.FC<Props> = ({ siteName, socialMedia }) => {
  return (
    <footer className="bg-white">
      <div className="max-w-6xl px-4 py-12 mx-auto sm:px-6 md:flex md:items-center md:justify-between lg:px-8">
        <div className="flex justify-center space-x-6 md:order-2">
          {socialMedia.map((item) => (
            <a key={item.name} href={item.href} target="__blank" className="text-gray-400 hover:text-blue-500">
              <span className="sr-only">{item.name}</span>
              <item.icon className="w-6 h-6" aria-hidden="true" />
            </a>
          ))}
        </div>
        <div className="mt-8 md:mt-0 md:order-1">
          <p className="text-base text-center text-gray-400">&copy; {(new Date()).getFullYear()} {siteName}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
